/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ColorsGrabberComponent as ɵb} from './lib/helpers/colors-grabber.component';
export {MaterialModule as ɵc} from './lib/material.module';
export {FOR_ROOT_OPTIONS_TOKEN as ɵd} from './lib/models/moduleOptions.model';
export {ModuleConfigurationService as ɵa} from './lib/services/configuration.service';